<template>
  <div :class="{hasLabel: label && showLabel}" :id="name">
    <label class="input-label" v-if="label && showLabel">{{label}}</label>
    <div class="input">
      <span class="input-wrapper">
        <input
          :type="inputType"
          :placeholder="placeholder"
          :name="name"
          v-model="content"
          @focus="handleFocus"
          @blur="handleBlur"
          @input="handleInput"
        />
      </span>
    </div>
    <label class="input-error empty">{{ `${label} is required`}}</label>
    <label class="input-error invalid">{{ `${label} is invalid`}}</label>
  </div>
</template>
<script>
import validator from '../../mixins/validator';

const TYPE_NUMBER = "NUMBER";
const TYPE_TEL = "tel";
const TYPE_FILE = "FILE";
export default {
  name: "input-text",
  mixins: [validator],
  props: {
    type: {
      type: String,
      default: "text"
    },
    placeholder: String,
    label: String,
    error: String,
    value: [Number, String],
    inValid: Function,
    isRequired: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    name: String,
  },
  data() {
    return {
      id: this.name,
    };
  },
  computed: {
    inputType() {
      const type = this.type.toUpperCase();
      if (type === TYPE_FILE) return "file";
      if (type === TYPE_TEL) return "tel";
      if (type === TYPE_NUMBER) return this.isMobile ? "tel" : this.type;
      return this.type;
    },
    inputPattern() {
      const type = this.type.toUpperCase();
      if (type === TYPE_TEL) return "^[0-9/\\]*$";
      if (type === TYPE_NUMBER) return "^[0-9]*$";
      return "";
    },
    isMobile() {
      //https://stackoverflow.com/a/21742107/1578100
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return (
        /android/i.test(userAgent) ||
        (/iPad|iPhone|iPhone/.test(userAgent) && !window.MSStream)
      );
    },
    content: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        //handled with $emit
      }
    }
  },
  methods: {
    handleFocus(e) {
      this.$el.setAttribute("focus", true);
      this.$emit("focus", this);
    },
    handleBlur(e) {
      e.preventDefault();
      this.$el.removeAttribute("focus");
      this.$emit("blur", this);
    },
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/_reset.scss";
@import "../../assets/css/_color.scss";

div[focus] {
  .input {
    border: 1px solid #1695a3;
  }
}
div.hasError {
  .input {
    border: 1px solid #e12f22;
  }
  &.empty {
    .input-error.empty {
      display: block;
    }
  }
  &.invalid {
    .input-error.invalid {
      display: block;
    }
  }
}
.input {
  width: 100%;
  color: #222;
  font-size: 20px;
  line-height: 30px;
  display: table;
  padding: 7px 16px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  border-radius: 4px;
}
.input-label {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
  color: #222;
  margin-bottom: 8px;
  text-transform: none;
}
.input-error {
  font-size: 14px;
  line-height: 20px;
  font-weight: normal;
  align-items: center;
  color: #b00020;
  margin-top: 4px;
  margin-bottom: 0;
  text-align: left;
  display: none;
  text-transform: none;
}
.input-wrapper {
  width: 100%;
  display: table-cell;
}

input {
  font-size: inherit;
  width: 100%;
  display: table-cell;
  border: 0;
  border-radius: 0;
  &::placeholder {
    font-size: inherit;
    font-weight: normal;
  }
}

.input-prefix,
.input-suffix {
  font-size: inherit;
  display: table-cell;
  white-space: nowrap;
}
.input-prefix {
  padding-right: 0.4em;
}
.input-suffix {
  padding-left: 0.4em;
}
</style>
